import { css, makeStyles } from '@conexasaude/conexa-hero'

const useStyles = makeStyles({
  titleWrapper: css`
    margin: 40px 0 12px 0;
    line-height: 24px;
  `,

  tableWrapper: ({ spacing }) => css`
    margin-bottom: ${spacing.sm};
  `,
})

export default useStyles
